/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Ai_Test_FailedInputs */

const en_ai_test_failed = /** @type {(inputs: Ai_Test_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Connection failed: ${i?.message}`)
};

const de_ai_test_failed = /** @type {(inputs: Ai_Test_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Verbindung fehlgeschlagen: ${i?.message}`)
};

/**
* | output |
* | --- |
* | "Connection failed: {message}" |
*
* @param {Ai_Test_FailedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ai_test_failed = /** @type {((inputs: Ai_Test_FailedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ai_Test_FailedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_ai_test_failed(inputs)
	return en_ai_test_failed(inputs)
});